module.exports = __webpack_public_path__ + "img/矩形 518@2x.1109c95f.png";